<!-- Línea superior: "Estás en la RED" -->
<div class="hero">Estás en la RED</div>

<!-- Sección principal -->
<div class="flex flex-row justify-between items-center h-[139.78px] px-4 bg-white shadow-sm">
  <!-- Logo -->
  <div class="flex items-center w-60 h-[118.78px] md:w-[385px] px-10 py-5">
    <img
      src="assets/images/logos/logo-grande.webp"
      [alt]="'Logo ' + institutionName"
      (click)="goHome()"
      class="h-full w-full object-contain hover:cursor-pointer"
    />
  </div>

  <button matButton [matMenuTriggerFor]="menu" class="md:hidden">
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" fill="var(--color-primary)" />
      <path
        d="M4 24V21.3333H28V24H4ZM4 17.3333V14.6667H28V17.3333H4ZM4 10.6667V8H28V10.6667H4Z"
        fill="var(--color-primary)"
      />
      <path
        d="M4 24V21.3333H28V24H4ZM4 17.3333V14.6667H28V17.3333H4ZM4 10.6667V8H28V10.6667H4Z"
        fill="white"
      />
    </svg>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="goPortalPaciente()">PORTAL PACIENTES</button>

    <button mat-menu-item [matMenuTriggerFor]="mobileServicios">SERVICIOS</button>
    <mat-menu #mobileServicios="matMenu">
      @for (service of siteConfig.navigation.services; track service.label) {
        <button mat-menu-item (click)="navigateTo(service.url)">
          {{ service.label }}
        </button>
      }
    </mat-menu>

    <button mat-menu-item [matMenuTriggerFor]="mobileSanatorio">{{ siteConfig.navigation.institutionMenuLabel }}</button>
    <mat-menu #mobileSanatorio="matMenu">
      @for (sanatorioItem of siteConfig.navigation.sanatorio; track sanatorioItem.label) {
        <button mat-menu-item (click)="navigateTo(sanatorioItem.url)">
          {{ sanatorioItem.label }}
        </button>
      }
    </mat-menu>
  </mat-menu>
</div>

<!-- Menú -->
<nav class="bg-[var(--color-primary)] text-white text-sm py-4 texto-nav max-md:hidden">
  <ul class="flex flex-wrap justify-center items-center text-xl">
    <li>
      <a
        href="{{ siteConfig.navigation.portalPacienteUrl }}"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Portal Pacientes"
        class="hover:cursor-pointer px-[1px] md:px-3"
        >PORTAL PACIENTES
      </a>
    </li>
    <li>|</li>
    <li>
      <button
        mat-button
        [matMenuTriggerFor]="servicesMenu"
        class="hover:cursor-pointer px-[1px] md:px-3 text-white flex items-center gap-1"
        aria-label="Servicios"
      >
        <div class="text-xl">SERVICIOS</div>
        <span class="material-icons text-base">arrow_drop_down</span>
      </button>

      <mat-menu #servicesMenu="matMenu" class="w-64">
        @for (service of siteConfig.navigation.services; track service.label) {
          <button mat-menu-item (click)="navigateTo(service.url)">
            <div class="pl-3">{{ service.label }}</div>
          </button>
        }
      </mat-menu>
    </li>
    <li>|</li>
    <li>
      <a
        href="{{ siteConfig.navigation.cuerpoProfesionalUrl }}"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Cuerpo profesional"
        class="hover:cursor-pointer px-[1px] md:px-3"
        >CUERPO PROFESIONAL</a
      >
    </li>
    <li>|</li>
    <li>
      <button
        mat-button
        [matMenuTriggerFor]="sanatorioMenu"
        class="hover:cursor-pointer px-[1px] md:px-3 text-white flex items-center gap-1"
        [attr.aria-label]="institutionName"
      >
        <div class="text-xl">{{ siteConfig.navigation.institutionMenuLabel }}</div>
        <span class="material-icons text-base">arrow_drop_down</span>
      </button>

      <mat-menu #sanatorioMenu="matMenu" class="w-64">
        @for (sanatorioItem of siteConfig.navigation.institucion; track sanatorioItem.label) {
          <button mat-menu-item (click)="navigateTo(sanatorioItem.url)">
            <div class="pl-3">{{ sanatorioItem.label }}</div>
          </button>
        }
      </mat-menu>
    </li>
  </ul>
</nav>
